import {ChangeEvent, ReactNode, useEffect, useRef, useState} from "react";
import {LoadingButton} from "@/components/common/LoadingButton";
// import {ItemPathObject} from "@/components/FileInput/index";
import {ButtonBaseProps, IconButtonProps, ButtonProps, Icon, MaterialIconName} from "@mui/material";
import {FileInputBase, FileInputBaseProps} from './FileInputBase';
import {FilePathObject} from './index';
import { AttachFile as FileIcon } from '@mui/icons-material';


interface FileInputButtonProps extends FileInputBaseProps {
    loading?: boolean,
    onChange?: (fileList?:FileList, value?:string, target?:HTMLInputElement) => void,
    children?: ReactNode,
    buttonType?: 'icon' | 'button' | 'fab',
    ButtonProps?: ButtonBaseProps & ButtonProps,
    size?: IconButtonProps['size'],
    color?: ButtonProps['color'],
    iconText?: MaterialIconName,
}
function FileInputButton({disabled, multiple, accept, setFilePathMap=() => {}, buttonType='button', onChange=()=>{}, ButtonProps={}, loading, size, color, iconText, ...props}:FileInputButtonProps) {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [files, setFiles] = useState<FileList>();
    const [isLoading, setIsLoading] = useState(false);

    async function handleFileChange(fileList:FileList | undefined, value:string, eventTarget:HTMLInputElement) {
        if (!fileInputRef.current || isLoading || disabled) return;
        try {
            const fileArr = fileList ? Array.from(fileList) : [];
            const pathMap:FilePathObject[] = [];

            fileArr.forEach(item => {
                const path = URL.createObjectURL(item);
                pathMap.push({
                    path: path,
                    mimeType: item.type,
                    size: item.size,
                    lastModified: item.lastModified,
                });
            })

            setFilePathMap(pathMap);

            setIsLoading(true);
            await onChange(fileList, value, eventTarget);
        } catch (e) {
            throw e;
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!fileInputRef.current) return;

        handleFileChange(files, fileInputRef.current?.value, fileInputRef.current).then(r => r);
    }, [files])

    return (
        <>
            <LoadingButton {...ButtonProps} disabled={disabled} isLoading={loading || isLoading} buttonType={buttonType} size={size} color={color} onClick={() => {
                if (!fileInputRef.current) return;

                fileInputRef.current.click();
            }}>
                {!!props?.children ? props?.children : <Icon fontSize={size === 'extra' ? 'small' : size}>{iconText || 'attach_file'}</Icon>}
            </LoadingButton>
            <FileInputBase ref={fileInputRef} onChanged={(ev:ChangeEvent<HTMLInputElement>) => {
                try {
                    if (!ev?.target?.files) return;

                    const currentFiles = ev.target.files;
                    console.log('onChanged', ev)

                    setFiles(currentFiles);
                } catch (e) {
                    console.error(e);
                }
            }} {...{disabled, multiple, accept, setFilePathMap}} style={{
                display: 'none',
            }} />
        </>
    )
}

export {
    FileInputButton,
    type FileInputButtonProps,
}

export default FileInputButton;